import { c as _c } from "react/compiler-runtime";
import type { BigIntish } from '@morpho-org/blue-sdk';
import { cn } from '@morpho-org/ui-v6/utils';
import { memo } from 'react';
import { useCountdown } from '@/components/VaultPage/hooks';
import { StyledVaultPendingTimelock } from '../VaultPendingTimelock.components';
interface VaultPendingTimelockCountdownProps {
  validAt: BigIntish;
}
const VaultPendingTimelockCountdown = t0 => {
  const $ = _c(6);
  const {
    validAt
  } = t0;
  const {
    formatted,
    isBelowOneHour
  } = useCountdown(validAt);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <span className="text-2xs text-foreground">Countdown</span>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const t2 = isBelowOneHour ? "text-warning-foreground" : "text-foreground";
  let t3;
  if ($[1] !== t2) {
    t3 = cn("text-2xs tabular-nums", t2);
    $[1] = t2;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== formatted || $[4] !== t3) {
    t4 = <StyledVaultPendingTimelock.Row>{t1}<span className={t3}>{formatted}</span></StyledVaultPendingTimelock.Row>;
    $[3] = formatted;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  return t4;
};
export default memo(VaultPendingTimelockCountdown);